import { RootState } from "../..";
import { OrderHistoryData, OrderMatchHistoryData } from "./types";

export const selectStockOrderHistoryData = (state: RootState): OrderHistoryData[] => state.user.stockOrderHistory.orderHistoryDatas;
export const selectStockOrderHistoryLoading = (state: RootState):boolean => state.user.stockOrderHistory.loading;

export const selectStockOrderMatchHistoryData = (state: RootState): OrderMatchHistoryData[] => state.user.stockOrderHistory.orderMatchHistoryDatas;
export const selectStockOrderMatchHistoryLoading = (state: RootState):boolean => state.user.stockOrderHistory.orderMatchLoading;